/**
 * Theme helper — desktop stores a per-profile `useLightTheme` flag. The web
 * has no profile at login time, so we persist the operator's preference in
 * localStorage and re-apply on every mount. Default: dark, same as desktop.
 */
const KEY = "signallens.theme";

export type ThemeMode = "dark" | "light";

export function readTheme(): ThemeMode {
	const stored = localStorage.getItem(KEY);
	return stored === "light" ? "light" : "dark";
}

export function writeTheme(mode: ThemeMode): void {
	localStorage.setItem(KEY, mode);
	document.documentElement.setAttribute("data-theme", mode);
}

export function applyTheme(mode: ThemeMode): void {
	document.documentElement.setAttribute("data-theme", mode);
}
